import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import {
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';
import { MIconMenu } from 'library';

import * as R from 'ramda';

import data from './mock.json';

const CustomToolbar = () => (
  <GridToolbarContainer>
    <GridToolbarColumnsButton variant="dataTable" />
    <GridToolbarFilterButton variant="dataTable" />
    <GridToolbarDensitySelector variant="dataTable" />
    <GridToolbarExport variant="dataTable" />
  </GridToolbarContainer>
);

const renderColor = R.cond([
  [R.equals('Closed'), R.always('graphic.light')],
  [R.equals('Unconfirmed'), R.always('warning.light')],
  [R.equals('Overdrawn'), R.always('error.light')],
  [R.equals('In Transit'), R.always('blue.light')],
]);

const columns = [
  {
    field: 'batchId',
    headerName: 'Batch Id',
    minWidth: 65,
  },
  {
    field: 'batchOwner',
    headerName: 'Batch Owner',
    minWidth: 140,
  },
  {
    field: 'originOwner',
    headerName: 'Origin Owner',
    minWidth: 140,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    renderCell: ({ row }) =>
      R.equals('Overdrawn', R.prop('status', row)) ? (
        <Tooltip enterTouchDelay={10} title="Go to PTO to transfer product">
          <Chip
            label={R.prop('status', row)}
            sx={{
              backgroundColor: renderColor(R.prop('status', row)),
            }}
          />
        </Tooltip>
      ) : (
        <Chip
          label={R.prop('status', row)}
          sx={{
            backgroundColor: renderColor(R.prop('status', row)),
          }}
        />
      ),
  },
  {
    field: 'acceptance',
    headerName: 'Acceptance',
    minWidth: 110,
  },
  {
    field: 'origin',
    headerName: 'Origin',
    minWidth: 170,
  },
  {
    field: 'product',
    headerName: 'Product',
    minWidth: 120,
  },
  {
    field: 'volume',
    headerName: 'Volume',
    minWidth: 100,
    renderCell: ({ row }) => <Typography variant="body1">{R.prop('volume', row)} bbl</Typography>,
  },
  {
    field: 'availableDate',
    headerName: 'Available Date',
    minWidth: 125,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 32,
    renderCell: () => (
      <MIconMenu
        items={[
          {
            label: 'View',
            onClick: () => {},
            value: 'view',
          },
          {
            label: 'Edit',
            onClick: () => {},
            value: 'edit',
          },
          {
            label: 'Cancel',
            onClick: () => {},
            value: 'cancel',
          },
        ]}
      />
    ),
  },
];

const newData = R.map((el, i) => ({ ...el, id: i }), data);

const Hidden = () => {
  const getRowSpacing = useCallback(params => {
    return {
      bottom: params.isLastVisible ? 0 : 8,
      top: 0,
    };
  }, []);

  return (
    <Box
      sx={{
        height: 700,
        mt: 8,
        px: 3,
        width: '100%',
      }}
    >
      <DataGridPro
        columns={columns}
        getRowId={R.prop('batchId')}
        getRowSpacing={getRowSpacing}
        rows={newData}
        slots={{
          Toolbar: CustomToolbar,
        }}
      />
    </Box>
  );
};

export default Hidden;
